import { Component, OnInit, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { UpsiParamService } from 'src/app/services/upsi-param.service';
declare var $: any;
import * as _ from 'lodash';
import { AlertComponent } from '../../alert/alert.component';

@Component({
  selector: 'app-upsiemaillog',
  templateUrl: './upsiemaillog.component.html',
  styleUrls: ['./upsiemaillog.component.css']
})
export class UpsiemaillogComponent implements OnInit {
  isSearchDivVisible = false;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  EmailsLogs: any;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dtInstance:DataTables.Api;
  EmailSubject: any;
  EmailAddressTo: any;
  EmailAddressCc:any;
  SearchDateFrom: any;
  SearchDateTo: any;
  paramData:any;
  constructor(private emailsLogService: UpsiParamService,   private alert: AlertComponent) { }

  ngOnInit() {
    var companyDetails = JSON.parse(localStorage.getItem("companyDetails"));
     this.paramData = {
      companyID: companyDetails.companyID
    }
    this.dtOptions = {
      processing: true,
      serverSide: false,
      scrollX: true,
      deferRender: true,
      stateSave: true,
      stateDuration: -1,
      scrollY: "420px",
      scrollCollapse: true,
      destroy: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [5, 'desc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],


    }    
    this.viewLog(this.paramData)
  }

  viewLog(paramData){
    this.emailsLogService.getEmailsLog(paramData).subscribe((emails:any) => {
     
      this.EmailsLogs = emails.data;
      if (this.dtElement.dtInstance != undefined) {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
        });
      }
      this.dtTrigger.next();
    })
  }

  viewEmails(data, CreatedDate) {
    let date = new Date(CreatedDate).getDate() + '-' + (new Date(CreatedDate).getMonth() + 1) + '-' + new Date(CreatedDate).getFullYear();
    $("#htmldata").html(data);
    $("#sentdate").html(date);
    $("#ViewHtmlEmail").modal('show')

  }

  searchData() {

    if (this.EmailSubject == null && this.EmailAddressCc == null && this.EmailAddressTo == null && this.SearchDateFrom == null && this.SearchDateTo == null) {
      this.alert.success("Enter  one of search data.");
      return;

    }

    var paramData = {
      EmailSubject: (this.EmailSubject != null && this.EmailSubject.trim() != '' && _.size(this.EmailSubject.trim())) ? this.EmailSubject.trim().toLowerCase() : null,
      EmailAddressTo: (this.EmailAddressTo != null && this.EmailAddressTo.trim() != '' && _.size(this.EmailAddressTo.trim())) ? this.EmailAddressTo.trim().toLowerCase() :null,
      EmailAddressCc: (this.EmailAddressCc != null && this.EmailAddressCc.trim() != '' && _.size(this.EmailAddressCc.trim())) ? this.EmailAddressCc.trim().toLowerCase() :null,
      CreatedFrom: (this.SearchDateFrom != null && this.SearchDateFrom != '' && _.size(this.SearchDateFrom)) ? this.setDate(this.SearchDateFrom) : null,
      CreatedTo: (this.SearchDateTo != null && this.SearchDateTo != '' && _.size(this.SearchDateTo)) ? this.setDate(this.SearchDateTo) : null,
    }
    this.viewLog(paramData);

  }
  clear() {    
    this.EmailSubject = null;
    this.EmailAddressTo = null;
    this.EmailAddressCc = null;
    this.SearchDateFrom = null;
    this.SearchDateTo = null;
    this.viewLog(this.paramData)
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.year + "-" + date.month + "-" + date.day;
    }
    return null;
  }

  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  maskEmail(email: string): string {
  if (email) {
    const [username, domain] = email.split('@');
    return username && domain ? `${username.slice(0, 3)}******@${domain}` : '';
  }
  return '';
}
}

